"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { apiService } from "../../services/apiService"

const Students = () => {
  const navigate = useNavigate()
  const [students, setStudents] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [filterLevel, setFilterLevel] = useState("all")
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    loadStudents()
  }, [])

  const loadStudents = async () => {
    try {
      setIsLoading(true)
      setError("")
      const data = await apiService.getStudents()
      setStudents(data)
    } catch (error) {
      console.error('Error loading students:', error)
      setError(error.message || 'Failed to load students')
    } finally {
      setIsLoading(false)
    }
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  const handleFilterChange = (e) => {
    setFilterLevel(e.target.value)
  }

  const handleViewAssignments = (studentId) => {
    navigate(`/mentor/student-assignments?student_id=${studentId}`)
  }

  const filteredStudents = students.filter((student) => {
    const matchesSearch =
      student.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
      student.email.toLowerCase().includes(searchTerm.toLowerCase())
    const matchesFilter = filterLevel === "all" || student.level === filterLevel

    return matchesSearch && matchesFilter
  })

  if (isLoading) {
    return <div className="loading">Loading students...</div>
  }

  if (error) {
    return <div className="error-message">{error}</div>
  }

  return (
    <div className="students-page">
      <div className="filters-container">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search students..."
            value={searchTerm}
            onChange={handleSearch}
            className="form-control"
          />
        </div>

        <div className="filter-box">
          <select value={filterLevel} onChange={handleFilterChange} className="form-control">
            <option value="all">All Levels</option>
            <option value="Basic">Basic</option>
            <option value="Intermediate">Intermediate</option>
            <option value="Advanced">Advanced</option>
          </select>
        </div>
      </div>

      <div className="students-list">
        {filteredStudents.length > 0 ? (
          filteredStudents.map((student) => (
            <div className="student-card" key={student.id}>
              <div className="student-avatar">
                <img src={student.profile_picture || require('../../images/Untitled.jpeg')} alt={student.username} />
              </div>

              <div className="student-info">
                <h3 className="student-name">{student.username}</h3>
                <p className="student-email">{student.email}</p>
                <p className="student-level">
                  Level: {student.level || 'Not Assigned'} ({student.current_day || 0}/{student.total_days || 0} days)
                </p>

                <div className="student-progress">
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: `${student.progress || 0}%` }}></div>
                  </div>
                  <span className="progress-text">{student.progress || 0}%</span>
                </div>
              </div>

              <div className="student-actions">
                <button 
                  className="btn btn-sm btn-secondary"
                  onClick={() => handleViewAssignments(student.id)}
                >
                  <i className="material-icons">assignment</i>
                  Assignments
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="no-results">
            <p>No students found matching your search criteria.</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default Students
